import { destructureAxiosReq } from '../services/utils';
import sureAxios from '../services/sureAxios';

/**
 * Send a login link email to allow user sign in.
 *
 * @param {String} email The email address to send the login link email to.
 */
export function sendLoginLink(email) {
  return sureAxios.post(`/api/auth/v1/send-login-link`, {
    email,
  });
}

/**
 * Log in using a token.
 *
 * @param {String} token The auth token
 */
export function login(token) {
  return destructureAxiosReq(sureAxios.post(`/api/auth/v1/login`, { token }));
}
